// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-forgetpassword-container{

  width: 100%;
  height: 100vh;
}
.swal2-title {
    color: #061522;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    }
    .inputDivStyle-forget{
        width: 368px;
    }
    .Forget-main-container{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #fff;
        min-height: calc(100vh - 134px);
    }

    
    @media screen and (max-width: 550px) {

        .textDiv {
          color: #5f44f7;
          margin: 0px 0px 0px 0px;
          font-size: 22px;
          margin-bottom: 25px;
        }
        .inputDivStyle-forget{
      
          width: 100%;
          padding: 24px;
        }
        .footer__trust {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #777777;
          border: none;
          outline: none;
          padding: 10px 5px;
        }
      }`, "",{"version":3,"sources":["webpack://./src/pages/ForgetPassword/style.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,aAAa;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;IACA;QACI,YAAY;IAChB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;QACtB,gBAAgB;QAChB,+BAA+B;IACnC;;;IAGA;;QAEI;UACE,cAAc;UACd,uBAAuB;UACvB,eAAe;UACf,mBAAmB;QACrB;QACA;;UAEE,WAAW;UACX,aAAa;QACf;QACA;UACE,WAAW;UACX,aAAa;UACb,sBAAsB;UACtB,uBAAuB;UACvB,mBAAmB;UACnB,cAAc;UACd,YAAY;UACZ,aAAa;UACb,iBAAiB;QACnB;MACF","sourcesContent":[".main-forgetpassword-container{\n\n  width: 100%;\n  height: 100vh;\n}\n.swal2-title {\n    color: #061522;\n    text-align: center;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    }\n    .inputDivStyle-forget{\n        width: 368px;\n    }\n    .Forget-main-container{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        background: #fff;\n        min-height: calc(100vh - 134px);\n    }\n\n    \n    @media screen and (max-width: 550px) {\n\n        .textDiv {\n          color: #5f44f7;\n          margin: 0px 0px 0px 0px;\n          font-size: 22px;\n          margin-bottom: 25px;\n        }\n        .inputDivStyle-forget{\n      \n          width: 100%;\n          padding: 24px;\n        }\n        .footer__trust {\n          width: 100%;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          color: #777777;\n          border: none;\n          outline: none;\n          padding: 10px 5px;\n        }\n      }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
